import { Star } from "lucide-react";
import { Container, Chapter, FadeUp } from "./primitives";

const TESTIMONIALS = [
  {
    quote:
      "We cut lead research from four hours a day to fifteen minutes. Our SDRs now spend their time in conversation, not in a search bar.",
    n: "Amelia Wu",
    r: "Founder & CEO",
    c: "Northwind Labs",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop&q=80",
  },
  {
    quote:
      "The approval workflow is the reason this scales inside our agency. Twelve accounts, one queue — every reply stays on-brand.",
    n: "Marcus Delacroix",
    r: "Head of Growth",
    c: "Octave Studio",
    img: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop&q=80",
  },
  {
    quote:
      "Intent scoring is uncanny. When SocialLead flags a thread at 90+, we book a demo 4 out of 5 times.",
    n: "Ines Alvarez",
    r: "CMO",
    c: "Parallel",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop&q=80",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="relative py-32 md:py-40 border-t border-white/10">
      <Container>
        <Chapter
          number="08"
          kicker="Testimonials"
          title={<>Teams that stopped guessing and started <span className="font-serif-x italic">shipping</span>.</>}
        />

        <div className="mt-16 space-y-10 md:space-y-14">
          {TESTIMONIALS.map((t, i) => (
            <FadeUp key={t.n} delay={i * 0.05}>
              <blockquote className={`relative grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-start border-t border-white/8 pt-10 md:pt-14`}>
                <div className="lg:col-span-8">
                  <div className="flex items-center gap-1 mb-6">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="h-3.5 w-3.5 text-white" fill="currentColor" strokeWidth={0} />
                    ))}
                  </div>
                  <p className="font-display text-[clamp(1.5rem,3vw,2.75rem)] tracking-[-0.02em] leading-[1.1] text-white">
                    “{t.quote}”
                  </p>
                </div>
                <div className="lg:col-span-4 flex items-center gap-4 lg:justify-end">
                  <img src={t.img} alt={t.n} className="h-14 w-14 rounded-full object-cover ring-1 ring-white/10" />
                  <div>
                    <div className="font-medium">{t.n}</div>
                    <div className="text-sm text-white/50">{t.r}, {t.c}</div>
                  </div>
                </div>
              </blockquote>
            </FadeUp>
          ))}
        </div>
      </Container>
    </section>
  );
}
